const ja = {
    ChatLayout: {
        nav_chat: "チャット",
        resource: "リソース管理",
        upload: "リソース登録",
        history: "履歴",
        setting: "設定",
        connection: "システム連携",
        delete: "削除",
        clear_messages: "クリア",
        back: "戻る",
    },
    NavBar: {
        chats: "チャット一覧",
        admin: "設定",
        settings: "プロフィール",
        logout: "ログアウト",
        saleslists: "リスト一覧",
        salestemplate: "テンプレート",
        usage: "利用状況",
        product_writing: "VectorFlux for Writing",
        product_sales: "VectorFlux for Sales",
        product_chat: "VectorFlux",
    },
    EditGroupView: {
        h1: "グループ編集：",
        group_name: "グループ名：",
        created_at: "作成日時：",
        modified_at: "最終更新日時：",
        user_group_h4: "グループのユーザー登録",
        username: "ユーザーID",
        fullname: "氏名",
        roles: "権限",
        user_group_h4_2: "登録可能のチャット",
        chat_title: "チャットボット名",
        submit: "更新",
        handleBack: "戻る",
        edit_group_err: "グループの編集は失敗しました！",
    },
    EditUserView: {
        h1: "ユーザー編集：",
        username: "ユーザーID：",
        mail_address: "メールアドレス：",
        full_name: "氏名：",
        password: "パスワード：",
        show: "表示",
        not_show: "非表示",
        roles: "権限：",
        groups: "グループ：",
        created_at: "アカウント登録日時：",
        modified_at: "最終更新日時：",
        submit: "更新",
        handleBack: "戻る",
        change_password: "パスワード初期化",
        password_format_err: "パスワードは最低8文字、大文字、小文字、数字、特殊文字を含む必要があります。",
        role_error: "権限を選択してください。",
        group_error: "ユーザー所属のグループを選択してください。",
    },
    NewGroupView: {
        h1: "グループ追加",
        group_name: "グループ名：",
        user_group_h4: "グループのユーザー登録",   
        username: "ユーザーID",
        fullname: "氏名",
        roles: "権限",
        user_group_h4_2: "グループのチャット登録",
        chat_title: "チャットボット名",
        submit: "保存",
        handleBack: "戻る",
        new_group_err: "グループ登録は失敗しました！\nすでに登録したグループかどうかを確認してください。",
        registered_group: "※すでに登録されたグループ名です。",
    },
    NewUserView: {
        h1: "ユーザー追加",
        username: "ユーザーID：",
        full_name: "氏名：",
        // mail_address: "電子郵件地址：",
        password: "パスワード：",
        show: "表示",
        not_show: "非表示",
        roles: "権限：",
        groups: "グループ：",
        submit: "新規登録",
        handleBack: "戻る",
        password_format_err: "パスワードは最低8文字、大文字、小文字、数字、特殊文字を含む必要があります。",
        role_error: "権限を選択してください。",
        group_error: "ユーザー所属のグループを選択してください。",
    },
    UserListView: {
        user_h4: "ユーザー一覧",
        add_User: "ユーザー追加",
        username: "ユーザーID",
        fullname: "氏名",
        roles: "権限",
        groups: "グループ",
        modified_at: "最終ログイン",
        created_at: "登録日時",
        operation: "操作",
        edit: "編集",
        delete: "削除",
        group_h4: "チャットアクセス権限グループ一覧",
        add_group: "グループ追加",
        group_name: "グループ名",
        update_date_time: "更新日時",
        ip_h4: "アクセス可能のIP一覧",
        ip_list: "IP",
        add_ip: "IP追加",
        modal_title: "警告",
        warning_msg_1: "グループを削除した場合",
        warning_msg_2: "グループに入ったユーザーとチャットはこのグループから解放されます。",
        warning_msg_3: "該当グループしか関連していないチャットは管理者以外のユーザーが閲覧、または編集できません。",
        warning_msg_4: "よろしいでしょうか？",
        user_warning_msg_1: "本当にユーザーを削除しますか？",
        cancel: "キャンセル",
        del_err: "グループの削除は失敗しました。\n存在していないグループです。\n画面をリフレッシュしてまた、操作してください。",
        ip_del_err: "IPの削除は失敗しました。",
        ip_edit_err: "IPアドレスではありません。IPアドレスを入力してください。",
        ip_edit_err2: "このIPアドレスは既に存在しています。",
        ip_save_err: "IPの保存は失敗しました。",
        save: "保存",
    },
    AdminErrorView: {
        h1: "アクセス権限がありません",
        error_message: "システム管理者にアクセス権限をリクエストするか、アクセス権のあるアカウントに切り替えてください。",
        back_button: "戻る",
    },
    ChatResourceUploadView: {
        h1: "リソース登録",
        resource_type: "リソースタイプ",
        file: "ファイル",
        choose_file: "ファイルを選択",
        file_name: "ファイル名",
        tags: "タグ",
        tags_format: "タグ1,タグ2,タグ3",
        upload: "アップロード",
        page_title: "ページタイトル",
        page_name: "ページ名",
        uploadWebResource: "登録",
        no_files_selected: "ファイルが選択されていません。",
        update_ok_msg: "アップロード成功。",
        update_err_msg: "アップロードに失敗しました。",
        response_ok_msg: "登録成功。",
        response_err_msg: "登録に失敗しました。",
        // not_pdf: "上傳的文件必須爲PDF文件",
    },
    ChatResourceView: {
        h4: "登録済みリソース一覧",
        keyword: "キーワード",
        tags: "タグ",
        total_number_of_characters: "文字数合計：",
        resource_count: "リソース数：",
        filter: "絞り込み",
        resource_name: "リソース名",
        file_type: "ファイル形式",
        created_at: "登録日時",
        status: "ステータス",
        operation: "操作",
        edit: "編集",
        delete: "削除",
        status_zero: "処理待ち",
        status_one: "読込中",
        status_two: "完了",
        status_three: "エラー",
    },
    ChatScreenView: {
        input_msg: "メッセージを入力してください",
        error_messages: "申し訳ありませんが、リクエスト中に問題が発生しました。しばらくしてからもう一度試してください。",
        close: "閉じる",
        template_message: "質問テンプレート",
        link: "外部リンク",
        new_talk: "+ 会話作成",
        his_talk: "会話履歴",
        memory_flag: "会話記憶",
    },
    ChatSettingView: {
        h4: "チャットボット設定",
        chat_namespace: "チャットID：",
        chat_title: "チャットボット名：",
        system_prompt: "システムプロンプト：",
        temperature: "応答の柔軟性：",
        model: "モデル",
        template_message: "選択肢メッセージ：",
        add: "追加",
        del: "削除",
        title: "タイトル",
        msg: "メッセージ内容",
        must: "入力必須",
        group: "閲覧可能のグループ",
        memory: "会話記憶",
        update: "更新",
        handle_return: "戻る",
        alert_max_10: "テンプレート登録は最大10個までです。",
        alert_not_edit: "選択肢メッセージに未記入の質問があります。\n質問を削除しまたは記入してください。",
        chat_setting_err_msg: "チャットの設定は失敗しました。",
        chat_setting_ok_msg: "チャットの設定は完了しました。",
    },
    NewChatView: {
        h3: "チャットボット作成",
        groups: "閲覧可能のグループ",
        chat_title: "チャットボット名：",
        system_prompt: "システムプロンプト：",
        temperature: "応答の柔軟性：",
        group_err: "閲覧できるグループを選択してください。",
        memory: "会話記憶",
        handleCreate: "新規登録",
        handleReturn: "戻る",
    },
    EditPasswordView: {
        h1: "パスワード変更",
        old_password: "元のパスワード：",
        incorrect_password: "パスワードが正しくありません！",
        new_password: "新しいパスワード：",
        new_password_confirmation: "新しいパスワード（確認）：",
        passwords_do_not_match: "パスワードが一致しません！",
        password_format_err: "パスワードは最低8文字、大文字、小文字、数字、特殊文字を含む必要があります。",
        submit: "変更",
        handleBack: "戻る",
    },
    SettingsView: {
        h4: "プロフィール",
        username: "ユーザーID：",
        full_name: "氏名：",
        mail_address: "メールアドレス：",
        not_mail_address: "入力したデータはメールアドレスではありません！",
        otp_on: "ログイン時にメールで２段階認証を行います。",
        otp_warning: "**注意：２段階認証を行う場合はメールアドレスが必須となります。",
        modal_title: "メールアドレス検証",
        modal_body: "認証コード：",
        otp_msg: "メールに送信した２段階認証コードを入力してください。",
        invalid_otp_code_1: "認証コードが正しくありません！",
        invalid_otp_code_2: "２段階認証はメールアドレスの入力が必須です。",
        setting_ok: "設定は完了しました。",
        send_btn: "送信",
        close_btn: "キャンセル",
        change_password: "パスワード変更",
        update: "更新",
        handle_return: "戻る",
        user_plan: "ご契約プラン照会",
    },
    UserPlanView: {
        plan_detail: "月次メッセージ数",
        element: "項目",
        used: "利用量",
        limit: "制限",
        fetch_error: "AIチャットの利用状況取得に失敗しました。しばらくしてから再度お試しください。",
        message_count_3: "メッセージ数(GPT-3.5)",
        message_count_4: "メッセージ数(GPT-4)",
        resource_detail: "リソース利用量",
        resource_characters_count: "リソース文字数",
        user_count: "ユーザー数",
        chat_count: "チャットボット数",
        handle_return: "戻る",
    },
    ChatListView: {
        h4: "チャットボット一覧",
        serach_keyword: "キーワード：",
        chat_count: "チャットボット数：",
        handle_create: "新規作成",
        handle_filter: "絞り込み",
        chat_title: "チャットボット名",
        author: "作成日時",
        operation: "操作",
        delete: "削除",
        modal_title: "警告",
        warning_msg_1: "チャットを削除します。",
        warning_msg_2: "よろしいでしょうか？",
        cancel: "キャンセル",
    },
    ChatView: {
        enter_message: "メッセージを入力してください",
        file_name: "ファイル名",
        tags: "タグ",
        source: "【参照元】：",
    },
    ChatEditResourceView: {
        h4: "リソース編集",
        resource_name: "リソース名：",
        file_type: "ファイル形式：",
        tags: "タグ",
        description: "備考：",
        status: "ステータス：",
        created_at: "登録日時：",
        modified_at: "更新日時：",
        resource_text: "テキスト：",
        submit: "更新",
        backToResources: "戻る",
        error_messages: "エラーが発生しました",
        close: "閉じる",
    },
    ChatConnectionView: {
        h4: "外部システム連携",
        messenger: "Messenger",
        messenger_service_name: "接続先サービス：",
        messenger_active_status: "有効状態：",
        messenger_callback_url: "コールバックURL：",
        messenger_verify_token: "認証トークン：",
        messenger_facebook_page_id: "FacebookページID：",
        messenger_access_token: "アクセストークン：",
        submit: "更新",
        hide_token: "非表示",
        show_token: "表示",
        error_messages: "エラーが発生しました",
        error_messages_fbduplicate: "facebookページIDが重複しているため更新できませんでした",
    },
    LoginView: {
        username: "ユーザー名：",
        invalid_username_or_password: "ユーザー名またはパスワードが正しくありません！",
        modal_title: "２段階認証",
        modal_body: "認証コード：",
        otp_msg: "メールに送信した２段階認証コードを入力してください。",
        invalid_otp_code_1: "認証コードが正しくありません！",
        invalid_otp_code_2: "認証回数が越えています。最初からやり直してください。",
        send_btn: "送信",
        close_btn: "キャンセル",
        password: "パスワード：",
        submit: "ログイン",
        session_expired_hint: "一定時間操作がなかったため、セッションの有効期限が切れました。もう一度ログインしてください。",
        ip_modal_title: "IP制限に関する情報",
        ip_err_1: "このPCのIPアドレスはログインできません。",
        ip_err_2: "IP権限管理者に連絡してください。",
    },
    RegisterView: {
        h4: "登録済みリソース一覧",
        search_keyword: "キーワード",
        tags: "タグ",
        total_number_of_characters: "文字数合計：",
        resource_count: "リソース数：",
        filter: "絞り込み",
        resource_name: "リソース名",
        file_type: "ファイル形式",
        created_at: "登録日時",
        status: "ステータス",
        operation: "操作",
        edit: "編集",
        delete: "削除",
    },
    UploadFileView: {
        upload_title: "リソース登録",
        resource_type: "リソースタイプ",
        file: "ファイル",
        file_upload: "ファイルを選択",
        file_name: "ファイル名",
        tags: "タグ",
        tags_format: "タグ1,タグ2,タグ3",
        uploadFile: "アップロード",
        document_title: "ページタイトル",
        uploadWebResource: "登録",
    },
    TagsInput: {
        admin_del_msg: "管理者が全てのチャットが管理できるために管理者ユーザー権限は削除できません。",
    },

    UploadServiceView: {
        // upload_title    : "1. リソース登録",
        resource_type: "リソースタイプ",
        file: "ファイル",
        file_upload: "ファイルを選択",
        // file_name       : "5. ファイル名",
        // tags            : "6. タグ",
        // tags_format     : "7. タグ1,タグ2,タグ3",
        uploadFile: "アップロード",
        // document_title  : "9. ページタイトル",
        uploadWebResource: "登録",
    },

    SalesListsView: {
        h4: "リスト一覧",
        search_keyword: "キーワード：",
        list_count: "リスト数：",
        sort_by: "並び替え：",
        sort_created_at: "作成日時",
        sort_modified_at: "更新日時",
        sort_order: "順序：",
        sort_desc: "新しい順",
        sort_asc: "古い順",
        handle_create: "新規作成",
        list_title: "リスト名",
        author: "作成日時",
        edit: "編集",
        delete: "削除",

        delete_confirm: "選択したリストを削除しますか？",
        OK: "削除する",
        cancel: "キャンセル"
    },

    SalesListsDetailsLayout: {
        h1: "リストタイトル1",
        company_list: "会社一覧",
        csv_import: "CSVインポート",
        company_setting: "リスト設定"
    },

    SalesListsDetailsView: {
        h4: "会社一覧",
        search_keyword: "キーワード:",
        handle_filter: "絞り込み",
        target_flag: "生成開始",
        target: "生成対象",
        regeneration: "再生成",
        company_information: "会社情報取得",
        text_generate: "文章生成",
        text_confirm: "内容確認",
        send_mail: "メール送信",
        data_count: "データ件数：",

        select_all: "全選択/解除",
        handleCreate: "+ 会社追加",
        handle_send: "一括送信",
        refresh: "一覧更新",
        handle_refresh: "一覧更新",

        selected: "対象",
        company_name: "会社名",
        company_url: "URL",

        crawl_status: "会社情報取得",
        generate_status: "文章生成",
        check_status: "文章確認",
        send_status: "メール送信",
        last_sent_at: "最終送信日時",

        process_pending: "処理待ち",
        processing: "処理中",
        finish: "完了",
        process_fail: "処理失敗",

        generate_pending: "生成待ち",
        generating: "生成中",
        generate_fail: "生成失敗",

        uncheck: "未確認",
        checked: "確認済",

        send_none: "未送信",
        send_pending: "送信待ち",
        send_processing: "送信中",
        send_finish: "送信済",
        send_fail: "送信失敗",
        send_delivered: "送信成功",
        send_open: "開封済",
        send_click: "クリック済",

        all: "全て",
        before_generation: "生成前",
        generated_unconfirmed: "生成完了・未確認",
        waiting_send: "送信前",
        completed: "送信完了",
        failed: "失敗",
        operation: "操作",
        edit: "確認・編集",
        delete: "削除",

        bulk_delete: "一括削除",
        bulk_delete_confirm_title: "一括削除",
        bulk_delete_confirm_message: "選択した会社を削除しますか？",

        delete_confirm: "を削除しますか?",
        OK: "OK",
        cancel: "キャンセル",
        send_mail_modal_title: "通知",
        send_mail_modal_text: "メール送信が予約されました。 ※「文章確認」=「確認済」のレコードのみ送信されます。",
        confirm_and_send: "確認済みにして送信",

        model_title: "会社編集・確認",
        model_company_name: "会社名：",
        model_person_name: "担当者名：",
        model_company_url: "URL:",
        model_email: "メールアドレス：",
        model_company_detail: "概要：",
        model_mail_text: "文章：",
        model_check_status: "確認済み：",
        model_update: "更新",
    },

    NewSalesListsDetailsView: {
        h3: "会社編集・確認",

        company_name: "会社名：",
        company_url: "URL:",
        email: "メールアドレス：",
        company_detail: "概要：",
        mail_text: "文章：",
        person_name: "担当者名：",

        return: "戻る",
        update: "更新",
    },

    NewSalesListsView: {
        h3: "リスト新規作成 ",

        resource_type: "リソースタイプ",
        file: "ファイル",

        title_base: "基本情報",
        title_service: "商品・サービス情報",
        title_template: "テンプレート選択",

        list_name: "リスト名",

        send_mode: "送信モード", 
        send_mode_auto: "自動判定",
        send_mode_mail: "メール送信のみ",
        send_mode_form: "フォーム送信のみ",

        sender_company_name: "【送信元】 会社名",
        sender_company_url: "【送信元】 会社HP",
        sender_name: "【送信元】 担当者名",
        sender_mail_address: "【送信元】 メールアドレス",

        furigana: "【送信元】 担当者名(フリガナ)",
        gender: "【送信元】 性別",
        pref: "【送信元】 都道府県",
        city: "【送信元】 市区町村",
        street_number: "【送信元】 番地",
        building_name: "【送信元】 建物名",
        postal_code: "【送信元】 郵便番号",
        tel: "【送信元】 電話番号",

        mail_title: "メールタイトル",
        to_name: "【送信先】 宛名",
        bcc: "【送信先】 BCC",
        to_name_default: "ご担当者様",
        file_upload: "*添付ファイル：",
        must_pdf: "*添付ファイルはpdfのみです。",
        not_pdf: "選択したファイルはpdfではありません。",

        service_name: "営業したい商品/サービスの名称",
        service_detail_summary: "営業したい商品/サービスの概要",
        multi_service_flag: "複数の商品/サービスからの自動提案機能",
        service_detail_template_name: "サービス詳細テンプレート",
        service_detail_template_apply: "適用",
        service_detail_template_save: "テンプレート保存",

        template_name: "テンプレートタイプ",

        additional_prompt: "プロンプト：",
        check_modal_title: "警告",
        check_modal_close: "閉じる",
        check_modal_msg: "リストを保存しましたが、必須項目が抜けているため生成・送信できません。以下の必須項目を入力してください。\n",

        return: "戻る",
        next: "次へ",
        finished: "完了",

        import: "ファイル・URLで入力",
    },

    EditSalesListsView: {
        h3: "リスト設定",

        resource_type: "リソースタイプ",
        file: "ファイル",

        title_base: "基本情報",
        title_service: "商品・サービス情報",
        title_template: "テンプレート選択",

        list_name: "リスト名",
        send_mode: "送信モード",
        send_mode_auto: "自動判定",
        send_mode_mail: "メール送信のみ",
        send_mode_form: "フォーム送信のみ",

        sender_company_name: "【送信元】 会社名",
        sender_company_url: "【送信元】 会社HP",
        sender_name: "【送信元】 担当者名",
        sender_mail_address: "【送信元】 メールアドレス",
        furigana: "【送信元】 担当者名(フリガナ)",
        gender: "【送信元】 性別",
        pref: "【送信元】 都道府県",
        city: "【送信元】 市区町村",
        street_number: "【送信元】 番地",
        building_name: "【送信元】 建物名",
        postal_code: "【送信元】 郵便番号",
        tel: "【送信元】 電話番号",
        mail_title: "メールタイトル",
        to_name: "【送信先】 宛名",
        bcc: "【送信先】 BCC",
        to_name_default: "ご担当者様",

        service_name: "営業したい商品/サービスの名称",
        service_detail_summary: "営業したい商品/サービスの概要",
        multi_service_flag: "複数の商品/サービスからの自動提案機能",
        service_detail_template_name: "サービス詳細テンプレート",
        service_detail_template_apply: "適用",
        service_detail_template_save: "テンプレート保存",

        template_name: "テンプレートタイプ",

        additional_prompt: "プロンプト",
        prompt_str: "【プロンプトとは？】<br>" +
            "本項目では、メール文面生成の際、生成AIに伝える制約事項を追記することができます。<br><br>" +
            "【具体例】<br>" +
            "・文字数を指定する: <br> 「600文字以内で作成してください。」<br><br>" +
            "・打ち合わせ予約リンクを挿入する:<br> 「本文の後半に以下の項目を必ず記載してください。<br>" +
            "“ご希望の方は、以下のリンクからご予約いただければと思います。<br>" +
            "◆ 打ち合わせ予約リンク https://～～～ ※1分程度でご予約が完了します”」<br>",
        multi_service_help: "ON にすると 「営業したい商品/サービスの概要」に記載された内容から営業先に最適な商品/サービスを自動で抽出して提案します。",

        check_modal_title: "警告",
        check_modal_close: "閉じる",
        check_modal_msg: "リストを保存しましたが、必須項目が抜けているため送信できません。以下の必須項目を入力してください。",
        isnot_valid_msg: "未入力の必須項目があります。生成・送信を可能にするには必須項目を入力して更新してください。",

        return: "戻る",
        next: "次へ",
        update: "更新",

        import: "ファイル・URLで入力",
        delete_title: "削除",
        delete_confirm: "添付ファイルを削除しますか？",
        OK: "削除する",
        cancel: "キャンセル"
    },

    SalesListsImportView: {
        h3: "CSVインポート",
        csv_drag: "CSVファイルをドラック&ドロップ、または",
        input_directly: "または CSVを使用せず直接入力する",

        table_name: "マッピング",

        field_name: "取り込み項目",
        csv_field: "CSVカラム",
        sample_value: "サンプル値",

        company_name: "会社名",
        company_url: "URL",
        company_detail: "会社概要",
        person_name: "担当者名",
        email: "メールアドレス",
        tel: "電話",
        contact_url: "連絡先URL",
        mail_text: "コンテンツの送信",

        upload_file: "インポート",
    },

    sales_templates: {
        h4: "メール文面テンプレート一覧",
        search_keyword: "キーワード：",
        list_count: "リスト数：",
        filter: "絞り込み",
        handle_create: "新規作成",
        list_title: "テンプレート名",
        author: "作成日時",
        edit: "編集",
        delete: "削除",

        delete_confirm: "選択したテンプレートを削除することを確認します?",
        OK: "もちろん",
        cancel: "キャンセル"
    },

    sales_templates_new: {
        h3: "テンプレート新規作成",

        template_name: "テンプレート名",
        template_text: "サンプルメール文面",

        new: "作成",
        cancel: "キャンセル",

        check_modal_title: "警告",
        check_modal_close: "閉じる",
        check_modal_msg: "は必須項目です。入力してください。",
    },

    service_detail_templates_new: {
        h3: "サービス詳細テンプレート新規作成",
        template_name: "テンプレート名",
        service_name: "商品・サービス名",
        service_detail_summary: "商品・サービス概要",
        new: "作成",
        cancel: "キャンセル",
        check_modal_msg: "は必須項目です。入力してください。",
    },

    sales_templates_edit: {
        h3: "テンプレートの編集",

        template_name: "テンプレート名",
        template_text: "サンプルメール文面",

        update: "更新する",
        cancel: "キャンセル",

        check_modal_title: "警告",
        check_modal_close: "閉じる",
        check_modal_msg: "は必須項目です。入力してください。",
    },

    SalesUsageDetailsView: {
        usage_detail: "ご利用状況",
        item: "項目",
        total_number: "合計件数",
        number_of_success: "成功数",
        number_of_failures: "失敗数",
        fetch_error: "請求データの取得に失敗しました。しばらくしてから再度お試しください。",
        number_of_articles_generated: "文章生成数：",
        number_of_emails_sent: "メール送信数：",
        number_of_form_sent: "フォーム送信数：",
        amount_detail: "ご利用金額",
        total_amount: "合計金額：",
        detail: "内訳：",
        quantity: "数量",
        unit_price: "単価",
        amount: "金額",
        base_amount: "基本利用料",
        base_amount1: "基本利用料(",
        base_amount2: "件まで含む)",
        append_amount: "追加生成分",
        back_button: "戻る"
    },

    OptionsErrorView: {
        h1: "アクセス権限がありません",
        error_message: "For Salesへのアクセス権限がありません。",
        back_button: "戻る"
    },

    company_db: {
        h3: "企業検索",

        categories: "業界",
        prefecture: "都道府県",
        capital_stock: "資本金",
        amount_sales: "売上高",
        established_year_month_min: "設立年月日",
        employee_number: "従業員数",
        offices_number: "事業所数",
        stores_number: "店鋪数",
        stock_market: "上場種別",

        stock_market_1: "東証プライム",
        stock_market_2: "東証スタンダード",
        stock_market_3: "東証グロース",

        stock_market_4: "名証プレミア",
        stock_market_5: "名証メイン",
        stock_market_6: "名証ネクスト",

        stock_market_7: "札幌証券取引所",
        stock_market_8: "アンビシャス",
        stock_market_9: "福岡証券取引所",

        stock_market_10: "未上場",

        filter_result: "絞り込み",
        import_result: "検索結果をインポート",

        f_title_0: "検索結果",
        f_title_1: "件中上位",
        f_title_2: "件サンプル",

        company_name: "会社名",
        company_url: "会社HP",
        representative_name: "代表者名",

        categories_title: "業界を選択する",

        import_title: "検索結果をインポート",
        import_list: "インポート先リスト",
        import_no: "インポート件数",
        import_begin: "インポート",

        alert_msg: "輸入数量は以下でなければなりません",
        message: "情報",
        inserted: "インポート成功",
        insert_fail: "インポートに失敗しました"
    },

    NavBarForWriting: {
        post_management_list: "投稿管理リスト",
        connect_to: "投稿先",
        usage: "利用状況",
        setting: "設定",
        logout: "ログアウト",
    },

    // fw00_check_point_limit.vue
    CheckOverPoints: {
        try_is_over: "無料トライアルが終了しました。スタンダードプランに登録してください。",
        register_standard_plan: "スタンダードプランに登録する",
    },

    // fw01_signin.vue
    SignIn: {
        register: "アカウント登録",
        free_trial: "無料トライアル",
        email: "メールアドレス",
        password: "パスワード",
        company_name: "会社名",
        full_name: "氏名",
        invalid_username_or_password: "ユーザー名またはパスワードが正しくありません！",
        username_already_exists: "このメールアドレスはすでに登録されています。",
        create_data_error: "ユーザーの作成に失敗しました。",
        login: "アカウント登録する",
        provider: "提供事業者",
        commercial_transaction: "特定商取引法に基づく表記",
        privacy_policy: "プライバシーポリシー",
        already_have_account: "すでにアカウントをお持ちですか？",
        go_to_login: "ログインページへ",
    },

    // fw02_login.vue
    LogIn: {
        email: "メールアドレス",
        password: "パスワード",
        invalid_username_or_password: "ユーザー名またはパスワードが正しくありません！",
        login: "ログイン",

        send_link: "マジックリンクメールを送信",
        forget_password: "パスワードをお忘れですか？",
        to_sign_up: "アカウントをお持ちではありませんか？サインアップ",
        no_account_yet: "まだアカウントをお持ちではありませんか？",
        go_to_signin: "アカウント登録ページへ",
        session_expired_hint: "一定時間操作がなかったため、セッションの有効期限が切れました。もう一度ログインしてください。",
        provider: "提供事業者",
        commercial_transaction: "特定商取引法に基づく表記",
        privacy_policy: "プライバシーポリシー",
    },

    // fw03_ArticleLists.vue
    ArticleLists: {
        h4: "投稿管理リスト一覧",
        search_keyword: "キーワード",
        filter: "絞り込み",
        count: "リスト数",
        create: "新規作成",
        list_title: "リスト名",
        author: "作成日時",
        delete: "削除",
        delete_prompt: "リスト: name を削除しますか？",
        OK: "はい",
        cancel: "キャンセル",
    },

    // fw04_ArticleLists_New.vue
    ArticleLists_New: {
        h3: "リスト新規作成",
        list_name: "リスト名",
        create: "作成する",
        return: "戻る",

        check_modal_title: "警告",
        check_modal_close: "閉じる",
        check_modal_msg: "は必須項目です。入力してください。",
    },

    // fw23_setting.vue.vue
    ArticleLists_Update: {
        h4: "リスト設定",
        list_name: "リスト名",
        update: "更新する",
        return: "戻る",

        check_modal_title: "警告",
        check_modal_close: "閉じる",
        check_modal_msg: "は必須項目です。入力してください。",
    },

    // fw23_setting.vue - GA Settings
    setting: {
        ga_integration: "連携設定",
        ga_overview: "Google Analyticsと連携すると、自社メディアの人気記事を分析し、新着記事のマッチ度判定プロンプトを自動生成できます。以下の3ステップで設定してください。",

        // Step 1: Property ID
        ga_help_step1_title: "STEP 1: GA Property IDを確認する",
        ga_help_step1_1: '<a href="https://analytics.google.com/" target="_blank">Google Analytics</a> にログインします。',
        ga_help_step1_2: '左下の <b>管理</b>（歯車アイコン）をクリックします。',
        ga_help_step1_3: '「プロパティ設定」>「プロパティの詳細」を開きます。',
        ga_help_step1_4: '「プロパティID」に表示されている <b>数字（例: 123456789）</b>をコピーし、下のフォームに貼り付けてください。',

        // Step 2: Service Account
        ga_help_step2_title: "STEP 2: サービスアカウントキーを作成する",
        ga_help_step2_1: '<a href="https://console.cloud.google.com/" target="_blank">Google Cloud Console</a> にログインします。',
        ga_help_step2_2: '上部の検索バーで <b>「Google Analytics Data API」</b> を検索し、APIを <b>有効</b> にします。',
        ga_help_step2_3: '左メニューから <b>「IAMと管理」>「サービスアカウント」</b> を開き、<b>「サービスアカウントを作成」</b> をクリックします。名前は任意（例: ga-reader）で、ロールの付与は不要です。',
        ga_help_step2_4: '作成したサービスアカウントを開き、<b>「鍵」タブ > 「鍵を追加」 > 「新しい鍵を作成」</b> で <b>JSON</b> を選択してダウンロードします。',
        ga_help_step2_5: 'ダウンロードしたJSONファイルを、下のフォームからアップロードしてください。',

        // Step 3: GA Access
        ga_help_step3_title: "STEP 3: サービスアカウントにGA閲覧権限を付与する",
        ga_help_step3_1: '<a href="https://analytics.google.com/" target="_blank">Google Analytics</a> の <b>管理</b>（歯車アイコン）を開きます。',
        ga_help_step3_2: '「プロパティのアクセス管理」を開き、右上の <b>「+」ボタン</b> をクリックします。',
        ga_help_step3_3: "STEP 2で作成したサービスアカウントのメールアドレス（例: <code>ga-reader{'@'}your-project.iam.gserviceaccount.com</code>）を入力します。<br>※ メールアドレスはダウンロードしたJSONファイル内の <code>client_email</code> に記載されています。",
        ga_help_step3_4: 'ロールは <b>「閲覧者」</b> を選択して追加してください。',

        ga_property_id_hint: "Google Analytics 4 の管理画面 > プロパティ設定 > プロパティの詳細に表示される数字です。",
        ga_service_account_key: "GAサービスアカウントキー（JSONファイル）",
        ga_key_uploaded: "サービスアカウントキーがアップロード済みです",
        ga_key_description: "STEP 2でダウンロードしたサービスアカウントキーのJSONファイルをアップロードしてください。",
        ga_save: "GA設定を保存",
        ga_test_connection: "接続テスト",
        ga_test_sample: "取得サンプル",

        // Media Analysis
        ga_analysis_title: "自社メディア分析",
        ga_analysis_description: "Google Analyticsのデータをもとに、自社メディアの人気記事の傾向をAIで分析します。分析結果は新着記事のマッチ度自動判定に使用されます。",
        ga_analyze_button: "人気記事を分析する",
        ga_analyzing: "分析中...",
        ga_last_analyzed: "最終分析日時",
        ga_analysis_result_label: "分析結果（人気記事の傾向・施策提案）",
        ga_match_prompt_label: "マッチ度判定プロンプト",
        ga_match_prompt_hint: "このプロンプトは新着記事のマッチ度判定に使用されます。GA分析で自動生成することも、手動で直接編集することもできます。",
        ga_match_prompt_placeholder: "例: 以下の記事は当メディアのターゲット読者に合致しますか？記事の内容、トーン、テーマが合致する場合はtrue、合致しない場合はfalseと判定してください。",
        ga_match_prompt_save: "プロンプトを保存",
        ga_save_success: "GA設定を保存しました。",
        ga_save_failed: "GA設定の保存に失敗しました。",
        ga_match_prompt_save_success: "保存しました。",
        ga_match_prompt_save_failed: "保存に失敗しました。",
        ga_test_failed: "接続テストに失敗しました。",
    },

    // fw05_Articles.vue
    Articles: {
        layout_title: "リストタイトル",

        nav_group_content: "コンテンツ管理",
        nav_group_collection: "記事収集",
        nav_group_generation: "記事生成設定",
        nav_group_settings: "設定・連携",

        articles: "生成記事一覧",
        futured_media: "アイキャッチ画像",
        ai_generation: "AI生成",
        category: "カテゴリ",
        sample_article: "サンプル記事",
        prompt_template: "プロンプト",
        css_selector: "CSSセレクター",
        css_selector_name: "CSSセレクター名",
        css_selector_new: "CSSセレクター新規追加",
        css_selector_edit: "CSSセレクター編集",
        domain_pattern: "ドメインパターン",
        domain_pattern_placeholder: "例: bbc.com",
        path_pattern: "パスパターン",
        path_pattern_placeholder: "例: /news/ または .* (デフォルト)",
        selectors_json_array: "セレクター (JSON配列)",
        selectors_placeholder: '例: ["#main-content", "article"]',
        priority: "優先度",
        priority_hint: "数字が小さいほど優先度が高い",
        connect_to: "投稿先",
        none: "無",
        dashboard: "ダッシュボード",
        crawl_sites: "取得サイト",
        crawl_articles: "新着記事一覧",
        article_list_setting: "リスト設定",

        search_keyword: "キーワード",
        filter: "絞り込み",

        article_generate_status: "生成状況",
        article_generate_status_0: "未対応",
        article_generate_status_1: "生成中",
        article_generate_status_2: "完了",
        article_generate_status_3: "エラー",

        cms_post_status: "投稿状況",
        cms_post_status_0: "未対応",
        cms_post_status_1: "投稿中",
        cms_post_status_2: "完了",
        cms_post_status_3: "エラー",

        create: "新規作成",
        post: "投稿",
        refresh: "一覧更新",

        select_all: "全選択/解除",

        selected: "対象",

        generate_type: "生成タイプ",
        generate_type_3: "元ネタから生成(URLから)",
        generate_type_4: "元ネタから生成(画像転載あり)",
        generate_type_5: "音声データから生成",
        generate_type_6: "テーマから生成",
        agent_instruction: "AI命令",
        agent_instruction_placeholder: "記事のテーマや要件を自然言語で入力してください。AIが自動でウェブ検索し、参照元を収集して記事を生成します。",
        keyword: "キーワード",
        urls: "元ネタURL / テキスト",
        audio_file: "音声ファイル",
        audio_select: "ファイルを選択",
        audio_hint: "対応形式: mp3, mp4, wav, m4a, ogg, flac など",
        audio_supplement: "補足情報（任意）",
        audio_supplement_placeholder: "例: テーマ「AIの活用事例」、話者: 田中（インタビュアー）、山田（専門家）",
        audio_no_file: "音声ファイル未設定",
        inline_images: "記事内画像",
        inline_images_select: "画像を選択",
        inline_images_hint: "記事内に配置する画像をアップロード（最大10枚）。画像の内容を分析し、本文の適切な位置に自動配置します。",
        subtitles: "見出し",
        sample_article_name: "参考記事タイプ",
        prompt_template_name: "プロンプトタイプ",
        additional_prompt: "追加プロンプト",
        additional_prompt_placeholder: "プロンプトテンプレートへの追加指示を入力（任意）",
        category_name: "カテゴリ",
        ai_model: "AIモデル",
        image_generation_mode: "画像生成モード",
        image_generation_mode_off: "無効",
        image_generation_mode_on: "有効",
        select_image_style: "画像スタイルを選択",
        image_style_realistic: "リアル",
        image_style_anime: "アニメ",
        image_style_illustration: "イラスト",
        image_style_photography: "写真",

        article_title: "タイトル",
        posted_url: "投稿先リンク",
        created_at: "生成日時",
        modified_at: "更新日時",

        edit: "編集",
        delete: "削除",
        delete_prompt: "記事: title を削除しますか？",

        OK: "はい",
        cancel: "キャンセル",

        regenerate: "生成する",

        check_modal_msg: "は必須項目です。入力してください。",
        connection_required: "接続先が設定されていません。投稿前に接続先を設定してください。",
        
        enable: "有効",
        update: "更新",
        append_2: "追加",
    },

    // fw37_dashboard.vue
    dashboard: {
        article_stats_title: "記事統計",
        total_articles: "記事合計",
        generate_status: "記事生成状況",
        cms_post_status: "投稿状況",
        analysis_language_label: "分析結果の言語",
        analysis_language_ja: "日本語",
        analysis_language_tw: "繁體中文",
        analysis_language_en: "English",
        status_not_started: "未対応",
        status_in_progress_gen: "生成中",
        status_completed: "完了",
        status_error: "エラー",
        status_in_progress_post: "投稿中",
        media_analysis_title: "自社メディア分析",
        recent_articles_title: "新着記事サマリー",
        recent_articles_empty: "新着記事はまだありません",
        crawl_sites_title: "取得サイト状況",
        crawl_sites_empty: "取得サイトはまだ登録されていません",
        site_name: "サイト名",
        last_crawled: "最終取得日時",
        active: "有効",
        inactive: "無効",
        not_crawled_yet: "未取得",
        match_score: "マッチ度",
        article_title: "記事タイトル",
        source_site: "取得元",
        crawled_at: "取得日時",
        active_sites: "有効サイト",
        total_sites: "全サイト",
        status_label: "状態",
        ga_analysis_success: "分析が完了しました。",
        ga_analysis_failed: "分析に失敗しました。",
    },

    // fw10_Articles_Edit.vue
    Articles_Edit: {
        h4: "生成条件",

        keyword: "キーワード",
        subtitles: "見出し",
        urls: "元ネタURL / テキスト",
        urls_placeholder: "https://example.com\nまたは元ネタとなるテキストを直接貼り付けてください",
        urls_hint: "URLまたはテキストを入力できます。URLの場合はページ内容を自動取得します。",
        sample_article_name: "参考記事タイプ",
        prompt_template_name: "プロンプトタイプ",
        additional_prompt: "追加プロンプト",
        additional_prompt_placeholder: "プロンプトテンプレートへの追加指示を入力（任意）",
        agent_instruction: "AI命令",
        agent_instruction_placeholder: "記事のテーマや要件を自然言語で入力してください。AIが自動でウェブ検索し、参照元を収集して記事を生成します。",
        generate_type: "生成タイプ",
        ai_model: "AIモデル",
        image_generation_mode: "画像生成モード",
        image_generation_mode_off: "無効",
        image_generation_mode_on: "有効",
        select_image_style: "画像スタイルを選択",
        image_style_realistic: "リアル",
        image_style_anime: "アニメ",
        image_style_illustration: "イラスト",
        image_style_photography: "写真",
        regenerate: "生成する",
        publish: "下書き投稿する",
        return: "戻る",
        return_to_list: "戻る",
        update: "更新する",

        generate_result: "生成結果",

        posted_url: "記事リンク",
        slug: "パーマリンク",

        article_title: "記事タイトル",
        futured_media: "アイキャッチ画像",
        connection: "投稿先",
        content: "本文",
        tags: "タグ",

        // 一次ソース判定
        primary_source_check: "一次ソース判定",
        primary_source_checking: "判定中...",
        primary_source_yes: "一次ソース",
        primary_source_no: "二次ソース",
        primary_source_unknown: "判定不能",
        primary_source_confidence: "確信度",
        primary_source_no_urls: "URLを入力してから判定してください",
        primary_source_error: "一次ソース判定中にエラーが発生しました",
    },

    // fw11_futured_medias.vue
    Futured_medias: {
        title: "アイキャッチ画像",

        search_keyword: "キーワード",
        filter: "絞り込み",

        append: "新規追加",
        delete_much: "一括削除",
        refresh: "一覧更新",

        select_all: "全選択/解除",
        selected: "対象",
        author: "作成日時",
        operation: "操作",

        image_upload: "画像アップロード",
        image_edit: "編集",

        drag_image: "画像をドラッグする",
        or: "または",
        select_file: "ファイルを選択",

        image: "イメージ",
        file_name: "ファイル名",

        content: "内容",
        append_2: "追加",
        return: "戻る",

        edit_category: "カテゴリ編集",
        update: "更新",

        OK: "はい",
        cancel: "キャンセル",

        edit: "編集",
        delete: "削除",

        delete_prompt: "プロンプトテンプレート: name を削除しますか？",
        delete_prompt_much: "プロンプトテンプレート: num 個のアイテムを削除してもよろしいですか？",

        png_alert: "PNGファイルをドラッグ/選択してください",
        feature_disabled: "この機能はまだ公開されていません",
    },

    // fw14_categories.vue
    Categories: {
        category: "カテゴリ",

        search_keyword: "キーワード",
        filter: "絞り込み",

        append: "新規追加",
        delete_much: "一括削除",
        refresh: "一覧更新",

        select_all: "全選択/解除",
        selected: "対象",
        category_name: "カテゴリ名",
        author: "作成日時",
        operation: "操作",

        new_category: "カテゴリ追加",
        append_2: "追加",
        return: "戻る",

        edit_category: "カテゴリ編集",
        update: "更新",

        OK: "はい",
        cancel: "キャンセル",

        edit: "編集",
        delete: "削除",

        delete_prompt: "カテゴリ: name を削除しますか？",
        delete_prompt_much: "カテゴリ: num 個のアイテムを削除してもよろしいですか？",
    },

    // fw17_sample_articles.vue
    Sample_articles: {
        title: "サンプル記事",

        search_keyword: "キーワード",
        filter: "絞り込み",

        append: "新規追加",
        delete_much: "一括削除",
        refresh: "一覧更新",

        select_all: "全選択/解除",
        selected: "対象",
        sample_articles: "サンプル記事",
        author: "作成日時",
        operation: "操作",

        new_sample_article: "サンプル記事 追加",
        edit_sample_article: "サンプル記事 編集",

        sample_article_name: "サンプル記事名",
        default: "デフォルト",
        content: "内容",
        append_2: "追加",
        return: "戻る",

        edit_category: "カテゴリ編集",
        update: "更新",

        OK: "はい",
        cancel: "キャンセル",

        edit: "編集",
        delete: "削除",

        delete_prompt: "カテゴリ: name を削除しますか？",
        delete_prompt_much: "カテゴリ: num 個のアイテムを削除してもよろしいですか？",

        extract_from_url: "URLから本文を抽出",
        extract_button: "抽出する",
        extracting: "抽出中...",
        extract_no_url: "URLを入力してください",
        extract_error: "本文の抽出に失敗しました",
    },

    // fw20_prompt_templates.vue
    prompt_templates: {
        title: "プロンプトテンプレート",

        new_prompt_templates: "プロンプト",
        edit_prompt_templates: "プロンプト 編集",

        search_keyword: "キーワード",
        filter: "絞り込み",

        append: "新規追加",
        delete_much: "一括削除",
        refresh: "一覧更新",

        select_all: "全選択/解除",
        selected: "対象",
        author: "作成日時",
        operation: "操作",

        prompt_template_name: "プロンプトテンプレート名",
        default: "デフォルト",
        content: "内容",
        append_2: "追加",
        return: "戻る",

        // edit_category: "カテゴリ編集",
        update: "更新",

        OK: "はい",
        cancel: "キャンセル",

        edit: "編集",
        delete: "削除",

        delete_prompt: "プロンプトテンプレート: name を削除しますか？",
        delete_prompt_much: "プロンプトテンプレート: num 個のアイテムを削除してもよろしいですか？",
    },

    // fw24_connections.vue
    connections: {
        title: "接続先",

        new_connection: "接続先 追加",
        edit_connection: "接続先 編集",

        search_keyword: "キーワード",
        filter: "絞り込み",

        append: "新規追加",
        delete_much: "一括削除",
        refresh: "一覧更新",

        select_all: "全選択/解除",
        selected: "対象",
        author: "作成日時",
        operation: "操作",

        connection_name: "接続先名",
        authentication_type: "認証タイプ",
        domain_url: "ベースURL",
        username: "ユーザーID",
        password: "パスワード",
        application_password: "アプリケーションパスワード",

        default: "デフォルト",
        append_2: "追加",
        return: "戻る",

        update: "更新",

        OK: "はい",
        cancel: "キャンセル",

        edit: "編集",
        delete: "削除",
        enable: "有効",

        delete_prompt: "プロンプトテンプレート: name を削除しますか？",
        delete_prompt_much: "プロンプトテンプレート: num 個のアイテムを削除してもよろしいですか？",
    },

    // fw34_usage.vue
    usage: {
        Trial: "トライアル",
        Standard: "スタンダード",

        use_trial_plan_now: "現在トライアルプランをご利用中です",
        register_standard_plan: "スタンダードプランに登録する",

        plan: "契約プラン",
        plan_name: "プラン名",
        plan_monthly_price: "基本料金",
        include_base_points: "ポイントまで含む",
        point_limit: "上限ポイント",
        point_price: "超過料金",
        points: "ポイント",

        usage: "ご利用状況",
        total_points: "合計消費ポイント",

        charge: "ご請求金額",
        over_billing: "超過ポイント料金",
        points_number: "ポイント分",
        billing_amount: "合計金額",
        cancel_success: "プランを解約しました。月末までは利用可能です。",
        already_cancelled: "既に解約済みです。",
        cancel_error: "解約処理でエラーが発生しました。",
        plan_modal_title: "スタンダードプランに申し込む",
        plan_basic_info: "◾️基本情報",
        plan_name_label: "プラン名",
        standard_plan_name: "スタンダードプラン",
        monthly_fee_label: "月額費用",
        monthly_fee_value: "35,000円（税抜）〜",
        points_granted_label: "ポイント付与数",
        points_granted_value: "600ポイント／月",
        extra_fee_label: "超過料金",
        extra_fee_value: "1ポイントあたり50円（税抜）",
        contract_billing_info: "◾️契約・請求関連",
        contract_period_label: "契約期間",
        contract_period_value: "月単位（自動更新）",
        proration_label: "初月日割り",
        proration_value: "契約日から日割り計算で課金",
        payment_method_label: "お支払い方法",
        payment_method_value: "クレジットカード（Stripe）",
        billing_timing_label: "請求タイミング",
        billing_timing_value: "毎月1日（または登録日に応じて）",
        cancel_policy_label: "キャンセル／解約",
        cancel_policy_value: "翌月更新日の前日までに解約可能",
        usage_points_info: "◾️利用内容・ポイントの仕組み",
        points_usage_target_label: "ポイント利用対象：",
        points_usage_target_value: "記事生成、見出し生成、要約などの各種AI機能",
        points_rules_label: "ポイント消費ルール：",
        points_range_1: "1〜2,000文字：",
        points_cost_1: "1ポイント",
        points_range_2: "2,001〜4,000文字：",
        points_cost_2: "2ポイント",
        points_range_3: "4,001〜6,000文字：",
        points_cost_3: "3ポイント",
        points_range_4: "6,001文字以上：",
        points_cost_4: "4ポイント",
        points_rollover: "ポイント繰越：なし（毎月リセット）",
        points_check_method: "ポイント確認方法：マイページより残高表示あり",
        notice_1_line_1: "※決済ページはStripeで安全に処理されます。",
        notice_1_line_2: "クレジットカード情報は当サイトでは保存されません。",
        notice_2_line_1: "※登録完了後すぐに、プランが有効になります。",
        notice_2_line_2: "ポイント残高はマイページでご確認ください。",
        cancel_button: "キャンセル",
        register_standard_plan_cta: "クレジットカードを登録してスタンダードプランに申し込む",
        cancel_modal_title: "プラン解約の確認",
        cancel_about_title: "解約について",
        cancel_rule_1: "解約後も、次回更新日（月末）までは利用可能です",
        cancel_rule_2: "更新日前に解約した場合、日割り返金はありません",
        cancel_rule_3: "再登録はいつでも可能です",
        warning_title: "注意事項",
        cancel_warning_text: "解約を実行すると、来月からスタンダードプランの料金請求が停止されます。",
        execute_cancel: "解約を実行する",
        proration_badge: "（日割り：{percent}%、{active_days}/{period_days}日）",
        cancel_plan_button: "プランを解約する",
        cancelled_status: "解約済み",
        cancelled_date: "解約日",
        cancelled_notice: "月末までは利用可能です。",
    },

    HomeView: {
        login_now: "今すぐログイン",
        enter_workspace: "ワークスペースへ",
        login_hint: "クレジットカード不要で始められます",
        feature_vector_search: "ベクトル検索",
        feature_ai_chat: "AI チャット",
        feature_smart_writing: "スマートライティング",
    },

    options_error_2: {
        h1              : "アクセス権限がありません",
        error_message   : "For Writing へのアクセス権限がありません。",
        back_button     : "戻る"
    },

    // fw35_crawl_sites.vue
    Crawl_sites: {
        title: "自動取得サイト",
        modal_new_title: "自動取得サイト 追加",
        modal_edit_title: "自動取得サイト 編集",
        site_name_label: "自動取得サイト名：",
        site_name_placeholder: "メディア名",
        news_page_url_label: "新着記事一覧ページURL：",
        match_threshold_label: "マッチ度閾値（%）：",
        match_threshold_hint: "※マッチ度判定プロンプトはリスト設定のGA連携から自動生成されます",
        generation_settings_title: "自動追加時の記事生成設定",
        generate_type: "生成タイプ",
        ai_model: "AIモデル",
        sample_article: "参考記事",
        prompt_template: "プロンプトタイプ",
        connection: "投稿先",
        select_placeholder: "-- 選択してください --",
        required: "必須",
        not_set: "未設定",
        add: "追加",
        update: "更新",
        back: "戻る",
        cancel: "キャンセル",
        active: "アクティブ",
        keyword: "キーワード：",
        filter: "絞り込み",
        new_item: "新規追加",
        refresh: "一覧更新",
        select_all: "全選択/解除",
        target: "対象",
        site_name: "サイト名",
        created_at: "作成日",
        operation: "操作",
        edit: "編集",
        crawl: "クロール",
        delete: "削除",
        required_settings_alert: "以下の記事生成設定は必須です：",
        create_failed: "作成に失敗しました",
        update_failed: "更新に失敗しました",
        delete_failed: "削除に失敗しました",
        crawl_started: "クロールを開始しました。新着記事一覧で結果を確認してください。",
        crawl_failed: "クロールの実行に失敗しました",
        delete_confirm: "「{site_name}」を削除しますか？関連する新着記事も削除されます。",
        auto_add_settings: "自動追加設定",
        auto_add_enabled: "閾値以上の新着記事を自動で記事一覧に追加する",
        auto_generate_enabled: "追加後すぐに記事生成を実行する",
        save_settings: "設定を保存",
        saving: "保存中...",
        auto_add_desc: "クロール完了時に閾値以上の記事が自動で追加されます。閾値は各サイトの設定で変更できます。",
    },
    Crawl_articles: {
        title: "新着記事一覧",
        modal_edit_title: "新着記事 編集",
        title_label: "タイトル：",
        url_label: "記事URL：",
        match_score_label: "マッチ度(AI判定)：",
        match_reason_label: "判定理由(AI判定)：",
        not_judged: "未判定",
        update: "更新",
        add_to_articles: "記事一覧に追加",
        dismiss: "却下",
        delete: "削除",
        back: "戻る",
        cancel: "キャンセル",
        keyword: "キーワード：",
        source_site_filter: "取得元サイト：",
        bulk_dismiss: "一括却下",
        bulk_delete: "一括削除",
        refresh: "一覧更新",
        select_all: "全選択/解除",
        target: "対象",
        site_name: "サイト名",
        article_title: "タイトル",
        url: "URL",
        created_at: "作成日",
        match_score: "マッチ度",
        status: "状態",
        operation: "操作",
        edit: "編集",
        page_size: "表示件数：",
        page_size_option: "{n}件",
        total_count: "{count}件",
        status_new: "未処理",
        status_added: "追加済み",
        status_dismissed: "却下",
        status_all: "すべて",
        select_article: "記事を選択してください",
        bulk_add_success: "{count}件の記事を記事一覧に追加しました",
        add_success: "記事一覧に追加しました",
        add_failed: "記事の追加に失敗しました",
        update_failed: "更新に失敗しました",
        delete_failed: "削除に失敗しました",
        dismiss_failed: "却下に失敗しました",
        refresh_failed: "更新に失敗しました",
        delete_confirm: "「{title}」を削除しますか？",
        bulk_delete_confirm: "{count}件の記事を削除しますか？",
    },
}
export default ja;